module.exports = __webpack_public_path__ + "static/media/sports.82a0cbc7.png";